import { httpRequest } from "@services/http";

export class CommandEditObjectiveJourneySteps {
    async run(engagementId: number, objectiveId: number, journeyStepId:number, steps: any) {
        const url = `${
          import.meta.env.VITE_API_PLATFORM_SERVICE_URL
        }api/v1/engagements/${engagementId}/objectives/${objectiveId}/journey-steps/${journeyStepId}/`

        const body = {
          id: steps.id,
          sequence: steps.sequence,
          landing_page_url: steps.landing_page_url,
          name: steps.name,
        }

        console.log(steps)
        try {
            const response = await httpRequest<any>(url, {method: "PUT", body})
            console.log("RESPONSE:")
            console.log(response)
            return response;
        } catch (error) {
            console.error("Error fetching data: ", error)
            throw error;
        }
    }
}